(function () {
  if (window.__bossIntlShippingTableInit) return;
  window.__bossIntlShippingTableInit = true;

  function badgeClass(service) {
    const value = String(service || '').toLowerCase();
    if (value.includes('dhl') || value.includes('fedex')) return 'boss-intl-shipping__badge--express';
    if (value.includes('ems')) return 'boss-intl-shipping__badge--ems';
    return 'boss-intl-shipping__badge--standard';
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderRows(tbody, rows) {
    const html = rows
      .map(function (row) {
        const service = row.service || '';
        return (
          '<tr data-country="' +
          escapeHtml((row.country || '').toLowerCase()) +
          '">' +
          '<td>' +
          escapeHtml(row.country || '') +
          '</td>' +
          '<td><span class="boss-intl-shipping__badge ' +
          badgeClass(service) +
          '">' +
          escapeHtml(service) +
          '</span></td>' +
          '<td>' +
          escapeHtml(row.time || '') +
          '</td>' +
          '</tr>'
        );
      })
      .join('');
    tbody.innerHTML = html;
  }

  function bindFilter(root, rows) {
    const input = root.querySelector('[data-boss-intl-filter]');
    const count = root.querySelector('[data-boss-intl-count]');
    const empty = root.querySelector('[data-boss-intl-empty]');
    const table = root.querySelector('[data-boss-intl-table]');
    const trs = root.querySelectorAll('[data-boss-intl-tbody] tr');

    function apply() {
      const query = (input && input.value ? input.value : '').trim().toLowerCase();
      let visible = 0;
      trs.forEach(function (tr) {
        const country = tr.getAttribute('data-country') || '';
        const show = !query || country.indexOf(query) !== -1;
        tr.hidden = !show;
        if (show) visible += 1;
      });
      if (count) count.textContent = visible + ' of ' + rows.length + ' countries';
      if (empty) empty.hidden = visible !== 0;
      if (table) table.hidden = visible === 0;
    }

    if (input) input.addEventListener('input', apply);
    apply();
  }

  async function initRoot(root) {
    const srcNode = document.querySelector('[data-boss-intl-shipping-src]');
    const tbody = root.querySelector('[data-boss-intl-tbody]');
    if (!srcNode || !tbody) return;

    let src = '';
    try {
      src = JSON.parse(srcNode.textContent || '""');
    } catch (e) {
      tbody.innerHTML = '<tr><td colspan="3">Unable to load delivery table.</td></tr>';
      return;
    }

    try {
      const response = await fetch(src, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('bad status');
      const rows = await response.json();
      if (!Array.isArray(rows) || !rows.length) throw new Error('empty');
      renderRows(tbody, rows);
      bindFilter(root, rows);
    } catch (e) {
      tbody.innerHTML = '<tr><td colspan="3">Unable to load delivery table.</td></tr>';
    }
  }

  function initAll() {
    document.querySelectorAll('.boss-intl-shipping').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
